"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var yup = require('yup');
var _require = require('../../helper/helper'),
  campusCodeToTenantCode = _require.campusCodeToTenantCode;
var PersonReference = /*#__PURE__*/function () {
  function PersonReference(opt) {
    _classCallCheck(this, PersonReference);
    this.userId = null;
    this.firstName = null;
    this.lastName = null;
    this.email = null;
    this.tenantCode = null;
    this.campusCode = null;
    if (opt) {
      this.fillObject(opt);
    }
  }
  _createClass(PersonReference, [{
    key: "fillObject",
    value: function fillObject(opt) {
      this.userId = opt.userId || opt.id || null;
      this.firstName = opt.firstName || null;
      this.lastName = opt.lastName || null;
      this.email = opt.email || null;
      this.tenantCode = opt.tenantCode || campusCodeToTenantCode(opt.campusCode);
      this.campusCode = opt.campusCode || null;
    }
  }], [{
    key: "schema",
    value: function schema() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (options.yup) {
        return yup.object({
          userId: yup.string().required(),
          firstName: yup.string().required(),
          lastName: yup.string().required(),
          email: yup.string().nullable(),
          tenantCode: yup.string().required(),
          campusCode: yup.string().required()
        }).from('id', 'userId');
      }
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'person-reference.schema.json',
        type: 'object',
        additionalProperties: false,
        properties: {
          userId: {
            type: 'string'
          },
          firstName: {
            type: ['string', 'null']
          },
          lastName: {
            type: ['string', 'null']
          },
          tenantCode: {
            type: ['string', 'null']
          },
          // TODO:: remove null
          campusCode: {
            type: 'string'
          },
          email: {
            type: ['string', 'null']
          }
        },
        required: Object.keys(this)
      };
    }
  }]);
  return PersonReference;
}();
module.exports = PersonReference;